/* eslint-disable */
// This is auto generated code, do not edit directly
// @ts-ignore
import * as Types from '../../graphql/generated/types';

import { gql } from '@apollo/client';
import { HcoCoreFragmentDoc } from './HCOCore.hook';
import { AddressSummaryFragmentDoc } from '../Address/Address.hook';
export type HcoSummaryFragment = {
	__typename?: 'HCO';
	vid_V: string;
	veevaid_V: string;
	statusCda_V?: string | null;
	statusCda_VId?: string | null;
	hcoNameCda_V?: string | null;
	hcoNameShort_V?: string | null;
	hcoNameEnglish_V?: string | null;
	hcoNameIntl_V?: string | null;
	hcoTypeCda_V?: string | null;
	addresses: Array<{
		__typename?: 'Address';
		vid_V: string;
		primaryCda_V?: boolean | null;
		cityCda_V?: string | null;
		cityIntl_V?: string | null;
		stateCda_V?: string | null;
		countryCda_V?: string | null;
		streetAddress1Cda_V?: string | null;
		streetAddress1Intl_V?: string | null;
		postalCodeCda_V?: string | null;
		postalCodeIntl_V?: string | null;
	}>;
	hcoType?: { __typename?: 'HCOType'; id: string; name: string } | null;
};

export const HcoSummaryFragmentDoc = gql`
	fragment HCOSummary on HCO {
		...HCOCore
		addresses(includeInactive: true) {
			...AddressSummary
		}
	}
	${HcoCoreFragmentDoc}
	${AddressSummaryFragmentDoc}
`;
